/*
 * File: InputText.js
 * Project: mp-mobile-app
 *
 * Copyright (c) 2019 MacPractice, Inc. All rights reserved.
 *
 * Description: Formatting for text input element
 */
import React from "react";
import PropTypes from "prop-types";
import { observer } from "mobx-react";
import UITextField from "components/ui/UITextField";
import FilledInput from "@material-ui/core/FilledInput";

const InputText = ({ field, value, error, parentOnChange, parentOnBlur }) => {
  return (
    <UITextField
      name={field.name}
      value={value}
      disabled={field.disabled}
      materialInputProps={field.materialInputProps}
      htmlInputProps={field.htmlInputProps}
      placeholder={field.placeholder}
      error={error}
      parentOnChange={parentOnChange}
      parentOnBlur={parentOnBlur}
      input={<FilledInput name={field.label} id={field.label} />}
      label={field.label}
    />
  );
};

InputText.propTypes = {
  field: PropTypes.object.isRequired,
  value: PropTypes.string,
  error: PropTypes.bool,
  parentOnChange: PropTypes.func.isRequired,
  parentOnBlur: PropTypes.func
};

export default observer(InputText);
